"use strict";

var _toConsumableArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommandsArbitrary = void 0;

var Converters_1 = require("../../check/arbitrary/definition/Converters");

var NextArbitrary_1 = require("../../check/arbitrary/definition/NextArbitrary");

var NextValue_1 = require("../../check/arbitrary/definition/NextValue");

var CommandsIterable_1 = require("../../check/model/commands/CommandsIterable");

var CommandWrapper_1 = require("../../check/model/commands/CommandWrapper");

var ReplayPath_1 = require("../../check/model/ReplayPath");

var LazyIterableIterator_1 = require("../../stream/LazyIterableIterator");

var Stream_1 = require("../../stream/Stream");

var oneof_1 = require("../oneof");

var RestrictedIntegerArbitraryBuilder_1 = require("./builders/RestrictedIntegerArbitraryBuilder");

var CommandsArbitrary = /*#__PURE__*/function (_NextArbitrary_1$Next) {
  _inherits(CommandsArbitrary, _NextArbitrary_1$Next);

  var _super = _createSuper(CommandsArbitrary);

  function CommandsArbitrary(commandArbs, maxGeneratedCommands, maxCommands, sourceReplayPath, disableReplayLog) {
    var _this;

    _classCallCheck(this, CommandsArbitrary);

    _this = _super.call(this);
    _this.sourceReplayPath = sourceReplayPath;
    _this.disableReplayLog = disableReplayLog;
    _this.oneCommandArb = (0, Converters_1.convertToNext)((0, oneof_1.oneof).apply(void 0, _toConsumableArray(commandArbs)).map(function (c) {
      return new CommandWrapper_1.CommandWrapper(c);
    }));
    _this.lengthArb = (0, Converters_1.convertToNext)((0, RestrictedIntegerArbitraryBuilder_1.restrictedIntegerArbitraryBuilder)(0, maxGeneratedCommands, maxCommands));
    _this.replayPath = [];
    _this.replayPathPosition = 0;
    return _this;
  }

  _createClass(CommandsArbitrary, [{
    key: "metadataForReplay",
    value: function metadataForReplay() {
      return this.disableReplayLog ? '' : "replayPath=".concat(JSON.stringify(ReplayPath_1.ReplayPath.stringify(this.replayPath)));
    }
  }, {
    key: "buildNextValueFor",
    value: function buildNextValueFor(items, shrunkOnce) {
      var _this2 = this;

      var commands = items.map(function (item) {
        return item.value_;
      });
      var context = {
        shrunkOnce: shrunkOnce,
        items: items
      };
      return new NextValue_1.NextValue(new CommandsIterable_1.CommandsIterable(commands, function () {
        return _this2.metadataForReplay();
      }), context);
    }
  }, {
    key: "generate",
    value: function generate(mrng) {
      var size = this.lengthArb.generate(mrng, undefined);
      var sizeValue = size.value;
      var items = Array(sizeValue);

      for (var idx = 0; idx !== sizeValue; ++idx) {
        var item = this.oneCommandArb.generate(mrng, undefined);
        items[idx] = item;
      }

      this.replayPathPosition = 0;
      return this.buildNextValueFor(items, false);
    }
  }, {
    key: "canShrinkWithoutContext",
    value: function canShrinkWithoutContext(value) {
      return false;
    }
  }, {
    key: "filterOnExecution",
    value: function filterOnExecution(itemsRaw) {
      var items = [];

      var _iterator = _createForOfIteratorHelper(itemsRaw),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var c = _step.value;

          if (c.value_.hasRan) {
            this.replayPath.push(true);
            items.push(c);
          } else this.replayPath.push(false);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return items;
    }
  }, {
    key: "filterOnReplay",
    value: function filterOnReplay(itemsRaw) {
      var _this3 = this;

      return itemsRaw.filter(function (c, idx) {
        var state = _this3.replayPath[_this3.replayPathPosition + idx];
        if (state === undefined) throw new Error("Too short replayPath");
        if (!state && c.value_.hasRan) throw new Error("Mismatch between replayPath and real execution");
        return state;
      });
    }
  }, {
    key: "filterForShrinkImpl",
    value: function filterForShrinkImpl(itemsRaw) {
      if (this.replayPathPosition === 0) {
        this.replayPath = this.sourceReplayPath !== null ? ReplayPath_1.ReplayPath.parse(this.sourceReplayPath) : [];
      }

      var items = this.replayPathPosition < this.replayPath.length ? this.filterOnReplay(itemsRaw) : this.filterOnExecution(itemsRaw);
      this.replayPathPosition += itemsRaw.length;
      return items;
    }
  }, {
    key: "shrink",
    value: function shrink(_value, context) {
      var _this4 = this;

      if (context === undefined) {
        return Stream_1.Stream.nil();
      }

      var safeContext = context;
      var shrunkOnce = safeContext.shrunkOnce;
      var itemsRaw = safeContext.items;
      var items = this.filterForShrinkImpl(itemsRaw);

      if (items.length === 0) {
        return Stream_1.Stream.nil();
      }

      var rootShrink = shrunkOnce ? Stream_1.Stream.nil() : new Stream_1.Stream([[]][Symbol.iterator]());
      var nextShrinks = [];

      var _loop = function _loop(numToKeep) {
        nextShrinks.push((0, LazyIterableIterator_1.makeLazy)(function () {
          var fixedStart = items.slice(0, numToKeep);
          return _this4.lengthArb.shrink(items.length - 1 - numToKeep, undefined).map(function (l) {
            return fixedStart.concat(items.slice(items.length - (l.value + 1)));
          });
        }));
      };

      for (var numToKeep = 0; numToKeep !== items.length; ++numToKeep) {
        _loop(numToKeep);
      }

      var _loop2 = function _loop2(itemAt) {
        nextShrinks.push((0, LazyIterableIterator_1.makeLazy)(function () {
          return _this4.oneCommandArb.shrink(items[itemAt].value_, items[itemAt].context).map(function (v) {
            return items.slice(0, itemAt).concat([v], items.slice(itemAt + 1));
          });
        }));
      };

      for (var itemAt = 0; itemAt !== items.length; ++itemAt) {
        _loop2(itemAt);
      }

      return rootShrink.join.apply(rootShrink, nextShrinks).map(function (shrinkables) {
        return _this4.buildNextValueFor(shrinkables.map(function (c) {
          return new NextValue_1.NextValue(c.value_.clone(), c.context);
        }), true);
      });
    }
  }]);

  return CommandsArbitrary;
}(NextArbitrary_1.NextArbitrary);

exports.CommandsArbitrary = CommandsArbitrary;